import { CHANGE_COMPARISON_PRODUCTS } from '../Actions/Comparison.action';
import { getData } from '../Services/LocalStorage.service';


export const comparison = (state = { count: getData("products", 0).length }, action) => {
    const { type, payload } = action;
    switch (type) {
        case CHANGE_COMPARISON_PRODUCTS:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};
